import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IAuthor } from 'src/app/core/models/i-author';

@Component({
  selector: 'app-authors-item',
  templateUrl: './authors-item.component.html',
  styleUrls: ['./authors-item.component.scss'],
})
export class AuthorsItemComponent implements OnInit {
  @Input() selectedAuthor: IAuthor;
  @Output() onRemoveAuthor = new EventEmitter();
  @Output() onEditLocation = new EventEmitter();
  @Output() onRefreshAuthor = new EventEmitter();
  authorLocationInput: FormControl = new FormControl();
  isEditingLocation: boolean = false;

  ngOnInit() {
    this.authorLocationInput.setValue(this.selectedAuthor?.location);
  }

  refreshAuthor(selectedAuthor) {
    this.onRefreshAuthor.emit(selectedAuthor);
  }

  removeAuthor(selectedAuthor) {
    this.onRemoveAuthor.emit(selectedAuthor);
  }

  updateSelectedAuthorLocation(selectedAuthor) {
    const updatedAuthor = {
      ...selectedAuthor,
      location: this.authorLocationInput.value,
    };
    this.onEditLocation.emit(updatedAuthor);
    this.isEditingLocation = false;
  }
}
